<template>
    <!-- 生产单详情-生产单表头部分 -->
    <el-descriptions border size="medium" column="4">
      <el-descriptions-item label="客户">{{productOrderHeader.customer}}</el-descriptions-item>
      <el-descriptions-item label="订单交期">{{productOrderHeader.consignTime}}</el-descriptions-item>
      <el-descriptions-item label="订单数量(米)">{{productOrderHeader.amount}}</el-descriptions-item>
      <el-descriptions-item label="工艺组织">{{productOrderHeader.craftOrganization}}</el-descriptions-item>

      <el-descriptions-item label="生产单编号">{{productOrderHeader.number}}</el-descriptions-item>
      <el-descriptions-item label="生产单状态">{{productOrderHeader.status}}</el-descriptions-item>
      <el-descriptions-item label="平方克">{{productOrderHeader.squareGrams}}</el-descriptions-item>
      <el-descriptions-item label="创建时间">{{productOrderHeader.createTime}}</el-descriptions-item>

      <el-descriptions-item label="针织密度(R/CM)">{{productOrderHeader.density}}</el-descriptions-item>
      <el-descriptions-item label="订单说明" span="3">{{productOrderHeader.remarks}}</el-descriptions-item>

      <el-descriptions-item label="胚布">{{productOrderHeader.fabricName}}</el-descriptions-item>
      <el-descriptions-item label="工艺说明" span="3">{{productOrderHeader.craftsheet.craftRemarks}}</el-descriptions-item>
    </el-descriptions>
</template>

<script>
export default {
  data() {
    return {
      productOrderHeader: {
        consignTime: '',
        customer: '',
        amount: '',
        craftOrganization: '',
        density: '',
        remarks: '',
        craftsheet: { craftRemarks: '' }
      }
    }
  },
  methods: {
    // 设置表头信息
    setProductOrderHeader(response) {
      this.productOrderHeader = this.formatProductOrderHeader(response)
    },
    // 格式化表单信息
    formatProductOrderHeader(res) {
      res.amount /= 100
      res.status = this.$enum.orderStatus[this.utils.formatEnum(res.status)[0]]
      res.consignTime = this.utils.timestampToTime(res.consignTime, 2)
      res.createTime = this.utils.timestampToTime(res.createTime)
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
